// react router
import { Link } from "react-router-dom";
import { BiSolidChevronsDown } from "react-icons/bi";
import styled from "styled-components";
// data
import { projects } from "../data/data";

// Home component - main page
const Home = () => {
  const featured = projects.filter((project) => {
    return project.featured === true;
  });

  return (
    <>
      <Wrapper className="hero select-off">
        <div className="hero-container">
          <div className="text-and-image">
            <div className="text-container">
              <h1>I'm Gavan</h1>
              <p>MERN stack developer</p>
            </div>
          </div>

          <Link to="projects" className="btn hero-btn">
            Explore Projects
          </Link>
          <div className="download-btn-container">
            <a
              href={require("../Gavan_Browne_CV.docx")}
              download="Gavan_Browne_CV"
              target="_blank"
              rel="noreferrer"
              className="btn hero-btn"
            >
              <div>
                <span>Download Résumé</span>
                <span>
                  <BiSolidChevronsDown />
                </span>
              </div>
            </a>
          </div>
        </div>
      </Wrapper>
      {/* <!-- projects --> */}
      <section className="section-featured  section-center">
        <div className="section-heading">
          <h2>
            <span>Featured</span> Projects
          </h2>
          <Link className="btn projects-btn" to="projects">
            All Projects
          </Link>
        </div>
        <div className="projects-grid">
          {/* <!-- projects go here --> */}
          {featured.map((project) => {
            const { name, id, imgLarge, imgMedium } = project;

            return (
              <article key={id} className="project-container">
                <Link to={`/project/${id}`}>
                  <img
                    width="792px"
                    height="446px"
                    className="project-img img"
                    srcSet={`${imgMedium} 440w, ${imgLarge} 792w`}
                    sizes="(max-width: 799px) 640px, (max-width: 991px) 430px, 792px"
                    src={imgLarge}
                    alt={name}
                  />
                </Link>
                <p className="project-title">{name}</p>
              </article>
            );
          })}
        </div>
      </section>

      {/* <!-- services --> */}
      <section className="section-about section-center">
        <div className="section-heading">
          <h2>
            <span>About</span>
          </h2>
        </div>
        <div className="services-grid">
          <section className="section-featured">
            <p className="paragraph-width">
              I have a diploma in computing from the Open University and am a
              member of Accounting Technicians Ireland. I'm looking for a junior
              front/backend developer role and can start immediately. An
              internship would also be great! Currently living in Leitrim, but,
              thanks to family, can work on a hybrid basis in Dublin quite
              easily. If hybrid or remote working is not possible, would
              definitely consider relocating.
            </p>
            <p className="paragraph-width">
              In the last several years I have worked through free online
              content on YouTube and have completed Udemy courses on HTML, CSS,
              JavaScript, Styled Components, NodeJS, Webpack 5, a MERN stack
              course where we built a front and backend project, and a React
              Testing Library & Jest course.
            </p>
            <p className="paragraph-width">
              I'm proficient with React, JavaScript, HTML5, CSS3, ES6+ syntax,
              Flexbox and Grid, NodeJS, Express, MongoDB Atlas, and have
              completed a TypeScript course. I have used Cypress for E2E testing
              in multiple projects. I use VSCode, GitHub, Netlify, Render.com
              for free backend hosting, MongoDB Atlas for data, Cloudinary to
              host media and SendGrid for email functionality.
            </p>
            <p className="paragraph-width">
              I will continue to post projects here as I consolidate my learning
              and further progress my front and backend development skills.
              Passionate about lifelong learning, I have Figma UI/UX design,
              Angular, SASS and Microservices (Node + React) courses lined up on
              Udemy.
            </p>
          </section>
        </div>
      </section>
    </>
  );
};

export default Home;

const Wrapper = styled.section`
  .download-btn-container {
    margin: 5rem auto 0 auto;
    max-width: fit-content;

    a {
      text-align: center;
      div {
        display: grid;
        padding: 0;
        margin: -0.3rem;
      }
    }
  }
  .text-container {
    display: flex;
    flex-direction: column;
  }
  .text-and-image {
    display: flex;
  }
  .gavan-image {
    margin-left: 2rem;
    width: 12rem;
    height: auto;
    border-radius: 50%;
    border: white solid 2px;
  }
  .headshot-container {
    display: grid;
    place-content: center;
  }
  @media screen and (max-width: 480px) {
    .gavan-image {
      width: 9rem;
      margin-left: 0;
    }
  }
`;
